import { makeReducerPermission } from "@atoms/atom-types";

export const clearAllPresetsPermission = makeReducerPermission({
  reducerName: "clearAllPresets",
});

export const clearAllInstrumentsPermission = makeReducerPermission({
  reducerName: "clearAllInstruments",
});

export const clearAllPriceDataPermission = makeReducerPermission({
  reducerName: "clearAllPriceData",
});

export const clearAllUserOptionsPermission = makeReducerPermission({
  reducerName: "clearAllUserOptions",
});

export const clearPositionPreviewsPermission = makeReducerPermission({
  reducerName: "clearPositionPreviews",
});

export const deleteAllPositionPreviewsPermission =
  clearPositionPreviewsPermission;

export const deleteModelAssetPermission = makeReducerPermission({
  reducerName: "deleteModelAsset",
});

export const deletePositionPreviewPermission = makeReducerPermission({
  reducerName: "deletePositionPreview",
});

export const exportExternalConfiguratorFilesPermission = makeReducerPermission({
  reducerName: "exportExternalConfiguratorFiles",
});

export const getUploadModelAssetUrlPermission = makeReducerPermission({
  reducerName: "getUploadModelAssetUrl",
});

export const getUploadPositionPreviewUrlPermission = makeReducerPermission({
  reducerName: "getUploadPositionPreviewUrl",
});

export const importPresetsFromJsonPermission = makeReducerPermission({
  reducerName: "importPresetsFromJson",
});

export const importInstrumentsPermission = makeReducerPermission({
  reducerName: "importInstruments",
});

export const importPriceDataPermission = makeReducerPermission({
  reducerName: "importPriceData",
});

export const importUserOptionsFromJsonPermission = makeReducerPermission({
  reducerName: "importUserOptionsFromJson",
});

export const processModelsArchivePermission = makeReducerPermission({
  reducerName: "processModelsArchive",
});

export const renameUserOptionPermission = makeReducerPermission({
  reducerName: "renameUserOption",
});

export const saveAsPresetPermission = makeReducerPermission({
  reducerName: "saveAsPreset",
});

export const saveInstrumentPermission = makeReducerPermission({
  reducerName: "saveInstrument",
});

export const setProductSettingsPermission = makeReducerPermission({
  reducerName: "setProductSettings",
});
export const triggerImportOrdersPermission = makeReducerPermission({
  reducerName: "triggerImportOrders",
});

export const afsImportApiPermission = makeReducerPermission({
  reducerName: "afsImportApi",
});
